<template>
  <div class="section">
    <div class="content">
      <h1>Alerts</h1>



      <table class="table is-striped">

        <thead>
        <tr>
          <th>Topic</th>
          <th>Date</th>
          <th>Text</th>


        </tr>
        </thead>
        <tbody>
        <tr v-for="(row,idx) in getAlerts" :key="'r'+idx" style="height: 60px;">
          <td>
            <router-link :to="{name:'Topic', 'params':{topicId:row.topicId}}">{{ row.title }}</router-link>
          </td>


          <td>{{ row.date }}</td>
          <td>{{ row.text }}</td>


        </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {


  data() {
    return {}
  },

  computed: {

    ...mapGetters({
      getAlerts: 'getAlerts'
    })
  }
}


</script>
